import React, { useEffect, useState } from 'react';

import { Modal, Button, Alert, Typography, notification } from 'antd';

import { BlinketSmallLogo } from 'components/Shared/Icons';
import eventStaffService from 'services/eventStaff';

import styles from './styles.module.css';
import AttendanceCard from '../QrCodeScanner/AttendanceCard';
import { Attendance } from '../QrCodeScanner/types';

const { Text } = Typography;
interface CheckinHistoryModalProps {
  staffToken: string;
  visible: boolean;
  onClose: () => void;
}

const CheckinHistoryModal = ({ staffToken, visible, onClose }: CheckinHistoryModalProps) => {
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [checkins, setCheckins] = useState<Attendance[]>([]);
  const [disabledAction, setDisabledAction] = useState(false);

  useEffect(() => {
    if (!staffToken || !visible) return;

    setLoadingHistory(true);

    const subscription = eventStaffService.getCheckinHistoryStaff(staffToken).subscribe({
      next: response => {
        const apiData = response || [];
        const parsedCheckins = apiData.map(
          (item: any): Attendance => ({
            attendance_id: item.attendance_id,
            ticket_name: item.ticket_name,
            lot_name: item.lot_name,
            invoice_id: item.invoice_id,
            invite_key: item.invite_key,
            name: item.name,
            document: item.document,
            checkin_date: item.checkin_date,
            checkin_request_date: item.checkin_date || null,
            custom_fields: item.custom_fields || []
          })
        );

        setCheckins(parsedCheckins);
        setLoadingHistory(false);
      },
      error: () => {
        notification.error({
          message: 'Erro ao buscar dados do credenciador. Verifique o link e tente novamente.'
        });
        setLoadingHistory(false);
      }
    });

    return () => subscription.unsubscribe();
  }, [staffToken, visible]);

  const removeCheckin = (inviteKey: string) => {
    const updated = checkins.filter(item => item.invite_key !== inviteKey);
    setCheckins(updated);

    if (updated.length === 0) {
      onClose();
    }
  };

  const updateAttendance = (updatedAttendance: Attendance) => {
    setCheckins(prevList =>
      prevList.map(item => (item.invite_key === updatedAttendance.invite_key ? updatedAttendance : item))
    );
  };

  return (
    <Modal
      loading={loadingHistory}
      title={
        <div className={styles.modalHeader}>
          <BlinketSmallLogo />
          <Text strong>Check-ins realizados pelo credenciador</Text>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button style={{ width: '100%' }} key='close' type='primary' onClick={onClose}>
          Fechar
        </Button>
      ]}
      centered
      className={styles.modal}
      wrapClassName={styles.modalWrapper}
      styles={{
        content: {
          padding: '20px 20px 120px 20px',
          margin: '0px',
          width: '100vw',
          height: '100vh',
          maxWidth: '440px',
          overflowY: 'scroll'
        }
      }}
    >
      <Text>Consulte o histórico de check-ins realizados por você.</Text>

      <Alert
        type='warning'
        message='Check-ins feitos por outros credenciadores não aparecem neste histórico.'
        showIcon
        className={styles.alert}
        closable={true}
      />

      {checkins.map(checkin => (
        <AttendanceCard
          key={checkin.invite_key}
          attendance={{
            attendance_id: checkin.attendance_id,
            ticket_name: checkin.ticket_name,
            lot_name: checkin.lot_name,
            invoice_id: checkin.invoice_id,
            invite_key: checkin.invite_key,
            name: checkin.name,
            document: checkin.document,
            checkin_date: checkin.checkin_date,
            checkin_request_date: checkin.checkin_request_date,
            custom_fields: checkin.custom_fields
          }}
          disabledAction={disabledAction}
          setDisabledAction={pending => setDisabledAction(pending)}
          onUndoCheckin={() => removeCheckin(checkin.invite_key)}
          staffToken={staffToken}
          onUpdateAttendance={updateAttendance}
        />
      ))}
    </Modal>
  );
};

export default CheckinHistoryModal;
